  <template >
<div>

 <div v-role="'est'"  class="formPosition">
 <template>
  <v-container class="grey lighten-5">

      <v-col >


<div class="text-center">

    <h2> Processando ...</h2> <br>


  </div>
 
      </v-col>

  </v-container>
  </template>
   </div>
</div>
</template>

<script>

   

import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
// const message = require('../config/messages')
export default {

  data: () => ({


  }),

  computed: {

    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },
    anolectivo () {
      return ls.get('anolectivo')
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    role () {
      let rl = ''
      if (ls.get('role') === 'ROLE_ADM') {
        rl = 'logado como Administrador'
      } else if (ls.get('role') === 'ROLE_PROF') {
        rl = 'logado como Professor'
      } else if (ls.get('role') === 'ROLE_FUNC') {
        rl = 'logado como Funcionario'
      } else if (ls.get('role') === 'ROLE_EST') {
        rl = 'logado como Estudante'
      } else if (ls.get('role') === 'ROLE_DIR') {
        rl = 'logado como Director'
      } else if (ls.get('role') === 'ROLE_COOR') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PED') {
        rl = 'logado como Sub-Director Pedagógico'
      } else if (ls.get('role') === 'ROLE_PWR') {
        rl = 'logado como Usuário com Superiores Previlêgios'
      } else if (ls.get('role') === 'ROLE_DIRCOL') {
        rl = 'logado como Director de Colégio'
      }
      return rl
    }
  },

  created () {
    // this.GetUserLocation()
  //  this.LoginlogsInsert('longitude', 'latitude')
    // console.log(ls.get('dataExpiracao'))
    this.ObterCursoCoordenador()
    setTimeout(() => {
      this.$router.push('solicitacoes-acesso-instituicao')
    }, 10000);
   
    
  },

  

  methods: {

    Teste(){
       alert('funciona')
    },

      
    async  GetUserLocation () {
      this.$getLocation()
        .then(coordinates => {
          let location = Object.values(coordinates)

          let valores = location.toString().split(',')
          let latitude = valores[0]
          let longitude = valores[1]

          this.LoginlogsInsert(longitude, latitude)
        })
    },

    async   ObterDataTimeRemote () {
      var today = new Date()
      var day = today.getDate() + ''
      var month = (today.getMonth() + 1) + ''
      var year = today.getFullYear() + ''
      var hour = today.getHours() + ''
      var minutes = today.getMinutes() + ''
      var seconds = today.getSeconds() + ''

      day = checkZero(day)
      month = checkZero(month)
      year = checkZero(year)
      hour = checkZero(hour)
      minutes = checkZero(minutes)
      seconds = checkZero(seconds)

      return (year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds)

      function checkZero (data) {
        if (data.length === 1) {
          data = '0' + data
        }
        return data
      }
    },

    async ObterCursoCoordenador () {
      if (ls.get('role') === 'ROLE_COOR') {
        try {
        // eslint-disable-next-line no-unused-vars
          let result = await axios
            .post('/obterCursoCoordenador')
            .then(res => res.data)
          if (result.length) {
            ls.set('idCursoCoordenador', result[0].idCurso)
          }
        } catch (error) {

        }
      }
    },

    async LoginlogsInsert (longitude, latitude) {
      let dtt = await this.ObterDataTimeRemote()
      const params =
      {
        loginUpdate: 0,
        username: ls.get('idPessoa'),
        nome: ls.get('nomeUsuario'),
        datain: dtt,
        dataout: '',
        autor: ls.get('nomeUsuario'),
        loginpkCode: ls.get('uuid'),
        instituicao: ls.get('instituicaodescricao'),
        role: ls.get('role'),
        latitude: 'latitude',
        longitude: 'longitude'

      }

      // consumindo a API
      try {
        // eslint-disable-next-line no-unused-vars
        let msg = await axios
          .post('/InsertOrUpdateLoginLogs', params)
          .then(res => res.data)
      } catch (error) {

      }
    }
  }
}
</script>
